// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"5bacf62ffe679c6e","964":"35a4967252dd7136"}[chunkId] + ".js";
};